export class EmoticonData {
	type: number;
	data = '';
	isCurrency = false;

	constructor(type: number, data?: string, isCurrency?: boolean) {
		this.type = type;
		this.data = data;
		this.isCurrency = isCurrency;
	}
}
